import { jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment, useMemo } from 'react';
import { observer } from 'mobx-react';
import isEmpty from 'lodash/isEmpty';
import { flattenTree, removeChildrenOf } from '@/common/components/Tree/Tree.utils';
import { TreeItemView } from './TreeItemView/TreeItemView';
function Tree(props) {
    const { items, selectedId, indentationWidth = 15, onSelect, onCollapse, itemClassName, itemContentClassName, renderItem, } = props;
    const flattenedItems = useMemo(() => {
        const collapsedItems = flattenTree(items).reduce((acc, { collapsed, original, id }) => (collapsed && original.children?.length ? [...acc, id] : acc), []);
        return removeChildrenOf(flattenTree(items), collapsedItems);
    }, [selectedId, items]);
    return (_jsx(Fragment, { children: flattenedItems.map(({ id, collapsed, original, depth }) => (_jsx(TreeItemView, { className: itemClassName, item: original, contentClassName: itemContentClassName, depth: depth, indentationWidth: indentationWidth, renderItem: renderItem, selected: id === selectedId, collapsed: collapsed && !isEmpty(original.children), onSelect: onSelect ? () => onSelect(original) : undefined, onCollapse: onCollapse && !isEmpty(original.children) ? () => onCollapse(original) : undefined }, id))) }));
}
export default observer(Tree);
